import { c as _c } from "react/compiler-runtime";
import type { DocumentUpload } from '@onefootprint/request-types/dashboard';
import { cx } from 'class-variance-authority';
import { useTranslation } from 'react-i18next';
import useDocumentUploadSideText from '@/entity/hooks/use-document-upload-side-text';
export type TableOfContentsProps = {
  latestAndSuccessfulUploads: (DocumentUpload & {
    isLatest: boolean;
  })[];
  failedUploads: (DocumentUpload & {
    isLatest: boolean;
  })[][];
  onClick: (index: number) => void;
  visibleIndex: number;
};
const TableOfContents = t0 => {
  const $ = _c(28);
  const {
    latestAndSuccessfulUploads,
    failedUploads,
    onClick,
    visibleIndex
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "fieldset.documents.details"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  const sideT = useDocumentUploadSideText();
  const totalUploads = latestAndSuccessfulUploads.length + failedUploads.flat().length;
  if (totalUploads === 1) {
    return null;
  }
  let t2;
  if ($[1] !== latestAndSuccessfulUploads || $[2] !== onClick || $[3] !== sideT || $[4] !== t || $[5] !== visibleIndex) {
    let t3;
    if ($[7] !== onClick || $[8] !== sideT || $[9] !== t || $[10] !== visibleIndex) {
      t3 = (t4, index) => {
        const {
          failureReasons,
          identifier,
          version,
          side
        } = t4;
        const isActive = index === visibleIndex;
        return <button key={`${identifier}:${version}`} className={cx("w-fit px-3 py-1 rounded-full text-label-2 bg-primary cursor-pointer border", {
          "border-accent text-accent shadow-elevation-2": isActive,
          "border-tertiary text-tertiary": !isActive
        })} type="button" onClick={() => onClick(index)}>{t(_temp, {
            side: sideT(side),
            status: failureReasons.length > 0 ? t(_temp2) : t(_temp3)
          })}</button>;
      };
      $[7] = onClick;
      $[8] = sideT;
      $[9] = t;
      $[10] = visibleIndex;
      $[11] = t3;
    } else {
      t3 = $[11];
    }
    t2 = latestAndSuccessfulUploads.map(t3);
    $[1] = latestAndSuccessfulUploads;
    $[2] = onClick;
    $[3] = sideT;
    $[4] = t;
    $[5] = visibleIndex;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[12] !== failedUploads || $[13] !== latestAndSuccessfulUploads.length || $[14] !== onClick || $[15] !== sideT || $[16] !== t || $[17] !== visibleIndex) {
    let t4;
    if ($[19] !== latestAndSuccessfulUploads.length || $[20] !== onClick || $[21] !== sideT || $[22] !== t || $[23] !== visibleIndex) {
      t4 = (sameSideUploads, index_0) => {
        const {
          identifier: identifier_0,
          version: version_0,
          side: side_0
        } = sameSideUploads[0];
        const actualIndex = index_0 + latestAndSuccessfulUploads.length;
        const isActive_0 = actualIndex === visibleIndex;
        return <button key={`${identifier_0}:${version_0}`} className={cx("w-fit px-3 py-1 rounded-full text-label-2 bg-primary cursor-pointer border", {
          "border-accent text-accent [box-shadow:rgba(5,5,5,0.14)_0px_4px_8px_0px]!": isActive_0,
          "border-tertiary text-tertiary": !isActive_0
        })} type="button" onClick={() => onClick(actualIndex)}>{t(_temp4, {
            side: sideT(side_0),
            status: t(_temp5, {
              count: sameSideUploads.length
            })
          })}</button>;
      };
      $[19] = latestAndSuccessfulUploads.length;
      $[20] = onClick;
      $[21] = sideT;
      $[22] = t;
      $[23] = visibleIndex;
      $[24] = t4;
    } else {
      t4 = $[24];
    }
    t3 = failedUploads.map(t4);
    $[12] = failedUploads;
    $[13] = latestAndSuccessfulUploads.length;
    $[14] = onClick;
    $[15] = sideT;
    $[16] = t;
    $[17] = visibleIndex;
    $[18] = t3;
  } else {
    t3 = $[18];
  }
  let t4;
  if ($[25] !== t2 || $[26] !== t3) {
    t4 = <div className="fixed bottom-3 left-[calc(16px+var(--drawer-width))] transition-[left] duration-200 ease-in-out z-[calc(theme(zIndex.drawer)+1)] flex self-start"><div className="flex flex-col gap-2">{t2}{t3}</div></div>;
    $[25] = t2;
    $[26] = t3;
    $[27] = t4;
  } else {
    t4 = $[27];
  }
  return t4;
};
export default TableOfContents;
function _temp($) {
  return $.tableOfContents.label;
}
function _temp2($_0) {
  return $_0.status.failed;
}
function _temp3($_1) {
  return $_1.status.success;
}
function _temp4($_2) {
  return $_2.tableOfContents.label;
}
function _temp5($_3) {
  return $_3.status.failedCount;
}